import React from "react";
import { useEffect } from "react";
import { action_fetch_order_list_shipped } from "../../../../../../../store/actions/pages/customer";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";
import { useSelector } from "react-redux";
import OrderList from "../fragments/order-list";
import OrderListEmpty from '../fragments/list-empty/index';
import { useCallback } from "react";
import { useDispatch } from "react-redux";

const OrderListShipped = props =>{
	const store = useStore();
	const params = useParams();
	const query = useQuery();
	const pageCustomer = useSelector(state=>state.pageCustomer);    
	const { orderListShipped } = pageCustomer;
	const dispatch = useDispatch();

	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			  // Allow the passed state to be garbage-collected
			  delete window.__INITIAL_STATE__
		  } else {
			if(orderListShipped?.data?.length <= 0){
				await OrderListShipped.fetchData(store, params, query)
			}
		  }
	}, []);

	const loadHandle = useCallback(() =>{
		dispatch(action_fetch_order_list_shipped(false));
	}, []);

    return <div>
        <OrderList 
			request={loadHandle}
			orders={orderListShipped?.data} 
			loading={orderListShipped?.loading}
			finished={orderListShipped?.skip!==0 && orderListShipped?.finished}
		/>

		{
			orderListShipped?.skip===0 && orderListShipped?.finished && <OrderListEmpty />
		}
    </div>
}

OrderListShipped.fetchData = async (store, params, search, headers) => {
	await store.dispatch(action_fetch_order_list_shipped(false, headers));
}

export default OrderListShipped;